import { Controller } from "@hotwired/stimulus"

// The monthly report's metric entry page (SMT_Report_Ash_Notes_Plan.md v3,
// item B): the screenshots chosen in the file input show as thumbnails
// BEFORE Save, each opening full size in a new tab, so the person can see
// they picked the right screens. Nothing uploads from here; the files go up
// with the entry form. Object URLs are local to this page and are released
// whenever the choice changes and when the page goes away.
export default class extends Controller {
  static targets = ["input", "list"]

  connect() {
    this.urls = []
  }

  disconnect() {
    this.release()
  }

  show() {
    this.release()
    this.listTarget.replaceChildren()
    Array.from(this.inputTarget.files || []).forEach(file => {
      const url = URL.createObjectURL(file)
      this.urls.push(url)
      this.listTarget.append(this.thumbnail(file, url))
    })
    this.listTarget.hidden = this.urls.length === 0
  }

  thumbnail(file, url) {
    const link = document.createElement("a")
    link.href = url
    link.target = "_blank"
    link.title = `${file.name} (opens full size)`
    link.className = "block w-28"
    link.dataset.screenshotPreview = "chosen"

    const name = document.createElement("span")
    name.textContent = file.name
    name.className = "block mt-1 text-[11px] text-[#8C8C8C] truncate"

    link.append(this.isHeic(file) ? this.heicTile() : this.image(file, url), name)
    return link
  }

  image(file, url) {
    const image = document.createElement("img")
    image.src = url
    image.alt = file.name
    image.className = "h-24 w-28 object-contain rounded-lg border border-[#E8E4DF] bg-[#F5F3F0]"
    return image
  }

  // Most browsers cannot draw HEIC, so a labeled tile stands in (the same
  // tile the saved list uses). Some browsers leave the type blank for HEIC,
  // so the extension counts too.
  heicTile() {
    const tile = document.createElement("span")
    tile.textContent = "HEIC"
    tile.dataset.heicTile = ""
    tile.className = "flex h-24 w-28 items-center justify-center rounded-lg border border-[#E8E4DF] bg-[#F5F3F0] text-xs font-semibold text-[#8C8C8C]"
    return tile
  }

  isHeic(file) {
    return ["image/heic", "image/heif"].includes(file.type) || /\.hei[cf]$/i.test(file.name)
  }

  release() {
    (this.urls || []).forEach(url => URL.revokeObjectURL(url))
    this.urls = []
  }
}
